// eslint-disable-next-line import/no-extraneous-dependencies
import { StatusEvent } from 'pubnub';

import { Timetoken } from '@sondermind/utilities/models-pubnub';

export enum StatusKind {
  ACCESS_DENIED = 'PNAccessDeniedCategory',
  CONNECTED = 'PNConnectedCategory',
  RECONNECTED = 'PNReconnectedCategory',
  NETWORK_UP = 'PNNetworkUpCategory',
  NETWORK_DOWN = 'PNNetworkDownCategory',
  UNKNOWN = '?'
}
export interface Status<K extends StatusKind> {
  kind: K;
  channels: string[];
  timetoken?: Timetoken;
}

export interface StatusUnknown {
  kind: StatusKind.UNKNOWN;
  channels?: string[];
  timetoken?: Timetoken;
  original: any;
}

export type StatusAccessDenied = Status<StatusKind.ACCESS_DENIED>;
export type StatusConnected = Status<StatusKind.CONNECTED>;
export type StatusNetworkUp = Status<StatusKind.NETWORK_UP>;
export type StatusNetworkDown = Status<StatusKind.NETWORK_DOWN>;
export type StatusReconnected = Status<StatusKind.RECONNECTED>;

export type Statuses =
  StatusAccessDenied
  | StatusConnected
  | StatusNetworkUp
  | StatusNetworkDown
  | StatusReconnected
  | StatusUnknown;

export function parseStatus(obj: StatusEvent): Statuses | null {
  // null, just ignore it
  if (obj == null) { return null }

  // not an object or message? it's unknown
  if (typeof obj !== 'object' || typeof obj.category !== 'string') {
    return <StatusUnknown>{ kind: StatusKind.UNKNOWN, original: obj };
  }

  // otherwise, check through known message kinds
  switch (obj.category) {
    case StatusKind.ACCESS_DENIED:
      return <StatusAccessDenied>{
        kind: StatusKind.ACCESS_DENIED,
        channels: obj.affectedChannels,
        timetoken: new Timetoken(obj.currentTimetoken)
      };

    case StatusKind.RECONNECTED:
      return <StatusReconnected>{
        kind: StatusKind.RECONNECTED,
        channels: obj.affectedChannels,
        timetoken: new Timetoken(obj.currentTimetoken)
      };

    case StatusKind.CONNECTED:
      return <StatusConnected>{
        kind: StatusKind.CONNECTED,
        channels: obj.affectedChannels,
        timetoken: new Timetoken(obj.currentTimetoken)
      };

    case StatusKind.NETWORK_UP:
      return <StatusNetworkUp>{
        kind: StatusKind.NETWORK_UP,
        channels: obj.affectedChannels
      };

    case StatusKind.NETWORK_DOWN:
      return <StatusNetworkDown>{
        kind: StatusKind.NETWORK_DOWN,
        channels: obj.affectedChannels
      };

    default:
      return <StatusUnknown>{
        kind: StatusKind.UNKNOWN,
        channel: obj.affectedChannels,
        timetoken: new Timetoken(obj.currentTimetoken),
        original: obj
      };
  }
}
